import axios from '../axiosConfig';
import React, { useEffect, useState } from 'react';
import TimePicker from 'react-times';
// use material theme
import 'react-times/css/material/default.css';
import { arreglarReloj, handleError, toastError, toastSuccess, toastWarningUnique } from '../funciones';
import FormInput from './FormInput';

// or you can use classic theme
//import 'react-times/css/classic/default.css';

export const ModalCambiarUnion = ({ perfil, cambiarUnion }) => {

    const [union, setUnion] = useState(-1);
    const [unionText, setUnionText] = useState(-1);


    function cambiarUnionHandler() {
        if (union === -1) {
            toastError("Debe seleccionar una unión");
            return;
        }

        cambiarUnion(
            perfil.id,
            parseInt(union) + 1,
            unionText
        ).then(() => {
            document.getElementById("btnCloseUnion").click();
        });
    }

    useEffect(() => {        
        setUnion(perfil.numeroUnion - 1)
    }, [perfil])

    function cerrarModal() {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 1) {
            localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);
            document.getElementById('abrirPerfil').click();
        }
    }

    return (
        <>

            <div class="modal fade " id="modalCambiarUnion" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 modal-inscripciones">

                        <div class="modal-body p-0">
                            <button type="button" id='btnCloseUnion' class="btn-close btn-close-modal" data-bs-dismiss="modal" aria-label="Close"
                                onClick={cerrarModal}></button>
                            <button id="abrirPerfil" class="d-none" data-bs-toggle="modal"
                                data-bs-target="#modalPerfil" />
                            <div className='container px-5 py-4'>
                                <div className='row'>
                                    <div className='col'>
                                        <h2 className='text-color-principal titulos text-center'>Modificar Unión</h2>
                                    </div>
                                </div>
                                <div className='row mt-4'>

                                    <label class="form-label letraDatos">Empresa:
                                        <div className='ms-2 d-inline-block'>{perfil.nombre}</div>
                                    </label>
                                </div>

                                <div className='row mt-2'>
                                    <FormInput id={"unionNueva"} text={"Seleccione la nueva unión:"} className={"col-12 w-lista-100"}
                                        mostrarTodas={false} idSeccion={0} setValue={setUnion} setText={setUnionText} value={union}/>
                                </div>
                                <div className='text-center py-2'>
                                    <button class="btn colorPrincipal text-white bold-botones mt-4 btn-cuadrado" type="submit" onClick={cambiarUnionHandler}>
                                        Modificar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}
